"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reducer = _interopRequireDefault(require("settings-ui-sdk/Blogs/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/BlogPosts/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/DesignTemplates/reducer"));

var _reducer4 = _interopRequireDefault(require("settings-ui-sdk/BlogLanguages/reducer"));

var _reducer5 = _interopRequireDefault(require("settings-ui-sdk/BlogNotificationEmails/reducer"));

var _redux = require("redux");

var _default = (0, _redux.combineReducers)({
  blogs: _reducer.default,
  blogPosts: _reducer2.default,
  templates: _reducer3.default,
  languages: _reducer4.default,
  notificationEmails: _reducer5.default
});

exports.default = _default;
module.exports = exports.default;